import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';

import { FetchDatasetParams } from '../types';

import { LciaMethod } from './types';

const fetchLciaMethods = async (params: Omit<FetchDatasetParams, 'dataset_id'>) => {
  const { data } = await api.get(`/spold/methods`, { params });

  return data;
};

const useLciaMethods = (isShowingV4: boolean, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<LciaMethod[], AxiosError>({
    queryKey: ['methods', version, system_model],
    queryFn: () => fetchLciaMethods({ version, system_model }),
    enabled: !isShowingV4,
    retry: false,
  });
};

export default useLciaMethods;
